import createFlags from 'flag'

const { FlagsProvider, Flag } = createFlags()

export {
  FlagsProvider,
  Flag
}
